<template>
  <div class="app-container">
    <el-card>
      <div class="top-btn">
        <div class="left">
          <el-button style="margin-right: 20px" type="primary" icon="el-icon-circle-plus-outline" @click="addLabel">添加标签</el-button>
          <el-input v-model="tableCondition.labelName" placeholder="标签名称模糊搜索" @input="getDelyList" />
        </div>
        <div class="right">
          <el-popover width="600" trigger="click">
            <el-button slot="reference" class="button_style">
              <svg-icon icon-class="combined_shape" />
              <span class="button_span_style">筛选列</span>
              <svg-icon icon-class="on_down" style="width: 8px; height: 8px; vertical-align: 0em" />
            </el-button>
            <div class="checkbox-table-headers">
              <template v-for="(item, index) in datasList.threads">
                <el-checkbox :key="index" v-model="item.show" :disabled="index == 0 || index == datasList.threads.length - 1">{{ item.name }}
                </el-checkbox>
              </template>
            </div>
          </el-popover>
        </div>
      </div>
      <div v-loading="tableLoading">
        <el-table
          border
          class="grayTableTile_01"
          :data="datasList.rows"
          style="width: 100%;margin-bottom: 20px;"
          row-key="labelName"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          @sort-change="handleSortChange"
        >
          <template v-for="(item,index) in datasList.threads">
            <el-table-column v-if="item.show" :label="item.name" :property="item.sortProperty" show-overflow-tooltip :sortable="item.sortFlag ? 'custom' : false">
              <template slot-scope="scope">
                <span>{{ scope.row[item.property] }}</span>
              </template>
            </el-table-column>
          </template>

          <el-table-column prop="address" label="操作" fixed="right" width="250">
            <template slot-scope="scope">
              <el-link v-if="scope.row.children" :underline="false" type="primary" @click="addChildLabel(scope.row)">
                添加子标签<span style="float: right;width: 1px;height: 16px;background: #cccccc; margin: 0px 10px; margin-top: 3px;" />
              </el-link>
              <el-link :underline="false" type="primary" @click="editLabel(scope.row)">
                编辑<span style="float: right;width: 1px;height: 16px;background: #cccccc; margin: 0px 10px; margin-top: 3px;" />
              </el-link>
              <el-link :underline="false" type="primary" @click="delLabel(scope.row)">
                删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          :total="tableCondition.total"
          :page.sync="tableCondition.pageNum"
          :limit.sync="tableCondition.pageSize"
          style="margin-top: 10px; padding: 10px 0px 10px 0px"
          @pagination="getList"
        />
      </div>

    </el-card>
    <el-dialog :visible.sync="labelDia">
      <div slot="title" ref="addLabelRef" />
      <el-form ref="labelRef" :model="labelForm" :rules="labelRule">
        <el-form-item v-if="labelForm.parName" label="父标签名称" label-width="120px">
          <span>{{ labelForm.parName }}</span>
        </el-form-item>
        <el-form-item label="标签名称" label-width="120px" prop="labelName">
          <el-input v-model="labelForm.labelName" autocomplete="off" />
        </el-form-item>
        <el-form-item label="备注" label-width="120px">
          <el-input v-model="labelForm.remark" autocomplete="off" type="textarea" :rows="5" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="labelDia = false">取 消</el-button>
        <el-button v-if="labelForm.id==0" type="primary" @click="handleAdd">确 定</el-button>
        <el-button v-else type="primary" @click="handleEdit">确 定</el-button>
      </div>
    </el-dialog>

    <ConfirmDialog ref="delLabelRef" @handleConfirm="handleDel" />
  </div>

</template>
<script>
import Pagination from '@/components/Pagination'
import { debounce } from 'lodash'
import ConfirmDialog from '../components/ConfirmDialog'
import { queryBy_searchForm, create_datasForm, update_datasForm, delete_datasForm } from '@Dcs~/api/tableLabel_model'

export default {
  components: { Pagination, ConfirmDialog },
  data() {
    return {
      labelDia: false,
      labelForm: {
        id: 0,
        labelName: '',
        remark: '',
        parName: '',
        labelParentId: 0
      },
      tableCondition: {
        total: 0,
        labelName: '',
        pageNum: 1,
        pageSize: 10,
        orderByColumn: '', // 排序字段
        isAsc: 'desc' // 排序方式
      },

      tableLoading: false,
      datasList: {
        rows: [],
        threads: [
          {
            name: '标签名称',
            property: 'labelName',
            sortFlag: false,
            sortProperty: 'labelName',
            show: true
          },
          {
            name: '创建人',
            property: 'createUser',
            sortFlag: false,
            sortProperty: 'createUser',
            show: true
          },
          {
            name: '添加时间',
            property: 'createTime',
            sortFlag: true,
            sortProperty: 'createTime',
            show: true
          },
          {
            name: '备注',
            property: 'remark',
            sortFlag: false,
            sortProperty: 'remark',
            show: true
          }
        ]
      },
      labelRule: {
        labelName: { required: true, message: '请输入标签名称', trigger: 'blur' },
        remark: { required: true, message: '请输入备注', trigger: 'blur' }
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.tableLoading = true
      queryBy_searchForm(this.tableCondition).then((res) => {
        if (res.code == 1) {
          this.datasList.rows = res.data.rows
          this.tableCondition.total = res.data.total
          this.tableLoading = false
        }
      })
    },
    getDelyList() {
      this.tableLoading = true
      const that = this
      this.getDeb(that)
    },
    getDeb: debounce((that) => {
      console.log(that.tableCondition)
      queryBy_searchForm(that.tableCondition).then((res) => {
        if (res.code == 1) {
          that.datasList.rows = res.data.rows
          that.datasList.rows.forEach((item) => {
            if (item.labelParentId == 0) {
              item.children = []
            }
          })
          that.tableCondition.total = res.data.total
          that.tableLoading = false
        }
      })
    }, 500),
    addLabel() {
      this.labelDia = true
      this.clearValidate()
      this.$refs['addLabelRef'].innerHTML = '添加标签'
    },
    handleAdd() {
      this.$refs['labelRef'].validate((valid) => {
        if (valid) {
          create_datasForm(this.labelForm).then((res) => {
            if (res.code == 1) {
              this.$message({
                message: '新增标签成功',
                type: 'success'
              })
              this.getList()
              this.labelDia = false
            }
          })
        }
      })
    },
    handleEdit() {
      this.$refs['labelRef'].validate((valid) => {
        if (valid) {
          update_datasForm(this.labelForm).then((res) => {
            if (res.code == 1) {
              this.$message({
                message: '编辑标签成功',
                type: 'success'
              })
              this.getList()
              this.labelDia = false
            }
          })
        }
      })
    },
    delLabel(row) {
      console.log(row)
      this.$refs['delLabelRef'].dialogVisible = true
      this.$refs['delLabelRef'].id = row.md5Id
    },
    handleDel(id) {
      delete_datasForm(id).then((res) => {
        if (res.code == 1) {
          this.$message({ message: '删除成功', type: 'success' })
          this.getList()
        }
      })
      console.log('请求删除' + id)
    },
    editLabel(row) {
      console.log(row)
      this.labelDia = true
      this.clearValidate()
      this.labelForm.labelName = row.labelName
      this.labelForm.remark = row.remark
      this.labelForm.id = row.id
      this.labelForm.labelParentId = row.labelParentId
    },
    addChildLabel(row) {
      this.labelDia = true
      this.$refs['addLabelRef'].innerHTML = '添加子标签'
      this.clearValidate()
      this.labelForm.parName = row.labelName
      this.labelForm.labelParentId = row.id
    },
    handleSortChange(e) {
      if (e.order === 'descending') {
        this.tableCondition.isAsc = 'DESC'
        this.tableCondition.orderByColumn = e.prop
        this.tableCondition.pageNum = 1
        this.getList()
      } else if (e.order === 'ascending') {
        this.tableCondition.isAsc = 'ASC'
        this.tableCondition.orderByColumn = e.prop
        this.tableCondition.pageNum = 1
        this.getList()
      }
      console.log(e)
    },
    clearValidate() {
      this.labelForm = this.$options.data().labelForm
      if (this.$refs['labelRef']) {
        this.$refs['labelRef'].clearValidate()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

    .top-btn {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .left{
            display: flex;
        }
        .right{

        }
    }
    .filterTableHeader {
        margin-right: 10px;
        float: right;
    }

    .button_style {
        font-size: 16px;
        padding: 8px 10px;
        border-radius: 6px;
        border: 1px solid #e5e5e5;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
        .button_span_style {
            font-weight: 400;
            line-height: 18px;
            font-size: 14px;
            padding: 0px 5px 0px 0px;
        }
    }

    .app-container {
        min-height: calc(100vh - 84px);
        background: #f0f2f5;
        padding: 0px 32px;
        padding-top: 23px;

        .el-card.is-always-shadow {
            box-shadow: 0 2px 12px 0 rgb(0 0 0 / 5%);
        }

        .card-box {
            padding: 4px;
            // ::v-deep .el-card__header {
            //   line-height: 30px;
            //   padding: 10px 15px;
            // }
        }

        > .el-select__tags {
            .el-tag {
                max-width: 60%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .el-select__input {
                margin-left: 2px;
            }
        }

        > .custom_form {
            .el-dialog__title {
                font-weight: 500;
                color: #333333;
                font-size: 20px;
            }

            .el-form-item__label {
                font-size: 14px;
                font-weight: 400;
                color: #666666;
            }
        }
    }

</style>
